// Convocatorias 2024

export const convocatoria001 = [
  {
    nombre: "Convocatoria 01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/CONVOCATORIA 01-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria002 = [
  {
    nombre: "Convocatoria 02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/CONVOCATORIA 02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria003 = [
  {
    nombre: "Convocatoria 03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/CONVOCATORIA 03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n1 = [
  {
    nombre: "Bases N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/BASES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/JUNTA DE ACLARACIONES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESP.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/FALLO EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n2 = [
  {
    nombre: "Bases N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/BASES EA-913005999-N2-2024 ALIMENTACION.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/JUNTA DE ACLARACIONES EA-913005999-N2-2024 ALIMENTACIÓN DE PERSONAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/PRESENTACION Y APERTURA DE PROPOSICIONES  EA-913005999-N2-2024 ALIEMTANCION DE PERSONAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/FALLO EA-913005999-N2-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n3 = [
  {
    nombre: "Bases N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/BASES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/JUNTA DE ACLARACIONES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/FALLO EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n4 = [
  {
    nombre: "Bases N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/BASES EA-913005999-N4-2024 SERVICIO DE TRASLADO DE VALORES.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/JUNTA DE ACLARACIONES EA-913005999-N4-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/FALLO EA-913005999-N4-2024 TRASLADO DE VALORES (2DO. PROCED.).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n5 = [
  {
    nombre: "Bases N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/BASES EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/JUNTA DE ACLARACIONES EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/APERTURA TECNICA Y ECONOMICA EA-913005999-N5-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/FALLO EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n6 = [
  {
    nombre: "Bases N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/BASES EA-913005999-N6-2024 SERVICIOS DE ACCESO DE INTERNET, REDES Y PROCESAMIENTO DE INFORMACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Junta de Aclaraciones EA-913005999-N6-2024 Servicios de Acceso de Internet, Redes y Procesamiento de Información.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Acta de Presentación y Apertura de Proposiciones EA-913005999-N6-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Acta de Fallo EA-913005999-N6-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP001 = [
  {
    nombre: "Convocatoria 01-2024 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CONVOCATORIA 01-2024 OBRA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop1 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/BASES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO PROYECTO FINAL DETALLES CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PLANO PROYECTO FINAL DETALLES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO PROYECTO FINAL PGDA CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PLANO PROYECTO FINAL PGDA CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACUERDO FE DE ERRATAS CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/ACUERDO FE DE ERRATAS CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // publicationDate: "2024-22-04",
            // new: "www.google.com",
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // publicationDate: "2024-22-04",
            // new: "www.google.com",
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/FALLO CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria004 = [
  {
    nombre: "Convocatoria 04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/CONVOCATORIA 04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria005 = [
  {
    nombre: "Convocatoria 05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/CONVOCATORIA 05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n7 = [
  {
    nombre: "Bases N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/BASES EA-913005999-N7-2024 CAPACTACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/JUNTA DE ACLARACIONES EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/APERTURA TECNICA ECONOMICA EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/FALLO EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n8 = [
  {
    nombre: "Bases N8",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N8/BASES EA-913005999-N8-2024 Combustibles, lubricantes y aditivos como materia prima.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N8",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N8/JUNTA DE ACLARACIONES EA-913005999-N8-2024 COMBUSTIBLES, LUBRICANTES Y ADITIVOS COMO MATERIA PRIMA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N8",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N8/Acta de Presentación y Apertura EA-913005999-N8-2024 Combustibles, Lubricantes y Aditivos como Materia Prima.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N8",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N8/FALLO EA-913005999-N8-2023 COMBUSTIBLES, LUBRICANTES Y ADITIVOS COMO MATERIA PRIMA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n9 = [
  {
    nombre: "Bases N9",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N9/BASES DE LICITACIÓN EA-913005999-N9-2024 MATERIAL DE LIMPIEZA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N9",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N9/JUNTA DE ACLARACIONES EA-913005999-N9-2024 MATERIAL DE LIMPIEZA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N9",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N9/Acta de Presentación y Apertura EA-913005999-N9-2024 Material de Limpieza.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO DIFERIDO N9",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N9/FALLO DIFERIDO ESA-913005999-N9-2024 MATERIAL DE LIMPIEZA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N9",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N9/FALLO  EA-913005999-N9-2024 MATERIAL DE LIMPIEZA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n10 = [
  {
    nombre: "Bases N10",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N10/BASES DE LICITACIÓN EA-913005999-N10-2024 SUSTANCIAS QUÍMICAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N10",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N10/JUNTA DE ACLARACIONES EA-913005999-N10-2024 SUSTANCIAS QUÍMICAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Continuación Junta de Aclaraciones N10",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N10/CONTINUACIÓN DE JUNTA DE ACLARACIONES EA-913005999-N10-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N10",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N10/Acta de Presentación y Apertura EA-913005999-N10-2024 Sustancias Químicas.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N10",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N10/Fallo EA-913005999-N10-2024 Sustancias Químicas.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n11 = [
  {
    nombre: "Bases N11",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N11/BASES EA-913005999-N11-2024 GASTOS DE ORDEN SOCIAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N11",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N11/JUNTA DE ACLARACIONES EA-913005999-N11-2024 GASTOS DE ORDEN SOCIAL.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N11",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N11/Acta de Presentación y Apertura EA-913005999-N11-2024 Gastos de Orden Social y cultural.PDF",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N11",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 05-2024/N11/FALLO EA-913005999-N11-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria006 = [
  {
    nombre: "Convocatoria 06-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/CONVOCATORIA 06-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n12 = [
  {
    nombre: "Bases N12",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N12/BASES DE LICITACIÓN EA-913005999-N12-2024 COMBUSTIBLES Y LUBRICANTES PARA VEHÍCULOS Y EQUIPOS TERRESTRES.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N12",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N12/JUNTA DE ACLARACIONES EA-913005999-N12-2024.pdf ",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N12",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N12/PRESENTACIÓN Y APERTURA DE PROPODICIONES EA-913005999-N12-2024 COMBUSTIBLES Y LUBRICANTES PARA VEHICULOS Y EQUIPOS TERRESTRES.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N12",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N12/FALLO EA-913005999-N12-2024 COMBUSTIBLES Y LUBRICANTES PARA VEHICULOS Y EQUIPO TERRESTRE.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n13 = [
  {
    nombre: "Bases N13",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N13/BASES DE LICITACIÓN EA-913005999-N13-2024 PRODUCTOS MINERALES NO METÁLICOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N13",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N13/JUNTA DE ACLARACIONES EA-913005999-N13-2024 PRODUCTOS MINERALES NO METÁLICOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N13",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N13/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N13-2024 PRODUCTOS MINERALES NO METÁLICOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N13",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N13/FALLO EA-913005999-N13-2024 PRODUCTOS MINERALES NO METÁLICOS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n14 = [
  {
    nombre: "Bases N14",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N14/BASES DE LICITACIÓN EA-913005999-N14-2024 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N14",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N14/JUNTA DE ACLARACIONES EA-913005999-N14-2024 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCION Y REPARACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N14",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N14/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N14-2024 OTROS MATERIALES Y ARTÍCULOS DE CONSTRUCCIÓN Y REPARACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N14",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N14/FALLO EA-913005999-N14-2024 OTROS MATERIALES Y ARTICULOS DE CONSTRUCCIÓN Y REPARACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n15 = [
  {
    nombre: "Bases N15",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N15/BASES DE LICITACIÓN EA-913005999-N15-2024 ADQUISICIÓN DE ADQUISICIÓN DE MONTACARGAS DE 3000KG.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N15",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N15/JUNTA DE ACLARACIONES EA-913005999-N15-2024 ADQUISICIÓN DE MONTACARGAS DE 3000KG.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N15",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N15/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N15-2024 ADQUISICIÓN DE MONTACARGAS DE 3000KG.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N15",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N15/FALLO EA-913005999-N15-2024 ADQUISICIÓN DE MONTACARGAS DE 3000KG.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n16 = [
  {
    nombre: "Bases N16",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N16/BASES DE LICITACIÓN EA-913005999-N16-2024 ADQ. DE MEDIDORES.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N16",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N16/JUNTA DE ACLARACIONES EA-913005999-N16-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N16",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N16/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N16-2024 ADQUISICIÓN DE MEDIDORES PARA EL SISTEMA COMERCIAL DE LA CAASIM.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N16",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N16/FALLO EA-913005999-N16-2024 ADQUISICIÓN DE MEDIDORES PARA EL SISTEMA COMERCIAL DE LA CAASIM.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n17 = [
  {
    nombre: "Bases 17",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N17/BASES DE LICITACIÓN EA-913005999-N17-2024 ADQUISICIÓN DE GRÚA TIPO HIAB.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N17",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N17/JUNTA DE ACLARACIONES EA-913005999-N17-2024 Adquisición de Grúa tipo HIAB.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N17",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N17/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N17-2024 ADQUISICIÓN DE GRUA TIPO Tipo HIAB.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N17",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N17/FALLO EA-913005999-N17-2024 ADQUISICIÓN DE GRÚA TIPO HIAB.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n18 = [
  {
    nombre: "Bases N18",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N18/BASES DE LICITACIÓN EA-913005999-N18-2024 ADQUISICIÓN DE DOS CAMIONES CISTERNA .pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N18",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N18/JUNTA DE ACLARACIONES EA-913005999-N18-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N18",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N18/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N18-2024 ADQUISICIÓN DE DOS CAMIONES CISTERNA DE 103 DE CAPACIDAD.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N18",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N18/FALLO EA-913005999-N18-2024 ADQUISICIÓN DE DOS CAMIONES CISTERNA DE 10 M3 DE CAPACIDAD.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n19 = [
  {
    nombre: "Bases N19",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N19/BASES DE LICITACIÓN EA-913005999-N19-2024 ADQUISICIÓN DE EQUIPO SEPTICO HIDRONEUMATICO PARA AGUAS NEGRAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N19",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N19/JUNTA DE ACLARACIONES EA-913005999-N19-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N19",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N19/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N19-2024 ADQUISICIÓN DE EQUIPO SÉPTICO HIDRONEUMÁTICO PARA AGUAS NEGRAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N19",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 06-2024/N19/FALLO EA-913005999-N19-2024 ADQUISICIÓN DE EQUIPO SÉPTICO HIDRONEUMÁTICO PARA AGUAS NEGRAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria007 = [
  {
    nombre: "Convocatoria 07-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/CONVOCATORIA 07-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n20 = [
  {
    nombre: "Bases N20",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/N20/BASES DE LICITACIÓN EA-913005999-N20-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N20",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/N20/JUNTA DE ACLARACIONES EA-913005999-N20-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N20",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/N20/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N20-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo Diferido N20",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/N20/FALLO DIFERIDO EA-913005999-N20-2024 MANTENIMIENTO DE MAQUINARIA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N20",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 07-2024/N20/FALLO EA-913005999-N20-2024 MANTENIMIENTO DE MAQUINARIA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaMultiple002 = [
  {
    nombre: "CONVOCATORIA MULTIPLE 02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CONVOCATORIA MULTIPLE 02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop2 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/BASES CAASIM-HGO-L.O.P.-02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Plano de Localización CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/PLANO DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2024001.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo CAASIM-HGO-L.O.P.-02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-02-2024/FALLO CAASIM-HGO-L.O.P.-02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop3 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/BASES CAASIM-HGO-L.O.P.-03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-03-2024 ",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Plano de Localización CAASIM-HGO-L.O.P.-03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/PLANO DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2024001.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura CAASIM-HGO-L.O.P.-03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo CAASIM-HGO-L.O.P.-03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-03-2024/FALLO CAASIM-HGO-L.O.P.-03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop4 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/BASES CAASIM-HGO-L.O.P.-04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Plano de Localización CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/PLANO DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2024001.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo CAASIM-HGO-L.O.P.-04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA MULTIPLE 02-2024/CAASIM-HGO-L.O.P.-04-2024/FALLO CAASIM-HGO-L.O.P.-04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria03Obra = [
  {
    nombre: "CONVOCATORIA 03-2024 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CONVOCATORIA 03-2024 OBRA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop5 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/BASES CAASIM-HGO-L.O.P.-05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Plano de Localización CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/PLANO DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-20001.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/PRESENTACIÓN Y APERTURA CAASIM-HGO-L.O.P.-05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo CAASIM-HGO-L.O.P.-05-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024 OBRA/CAASIM-HGO-L.O.P.-05-2024/FALLO CAASIM-HGO-L.O.P.-05-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria008 = [
  {
    nombre: "CONVOCATORIA 08-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/CONVOCATORIA 08-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n22 = [
  {
    nombre: "Bases N22",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N22/BASES DE LICITACIÓN EA-913005999-N22-2024 PRODUCTOS MINERALES NO METÁLICOS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N22",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N22/JUNTA DE ACLARACIONES EA-913005999-N22-2024 PRODUCTOS MINERALES NO METÁLICOS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "Bases N22",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N22/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const n24 = [
  {
    nombre: "Bases N24",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N24/BASES DE LICITACIÓN EA-913005999-N24-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N24",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N24/JUNTA DE ACLARACIONES EA-913005999-N24-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "Bases N24",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N24/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const n25 = [
  {
    nombre: "Bases N25",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N25/BASES DE LICITACIÓN EA-913005999-N25-2024 MANTENIMIENTO E INSTALACIÓN DE EQUIPO Y HERRAMIENTAS PARA SUMINISTRO DE AGUA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N25",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N25/JUNTA DE ACLARACIONES EA-913005999-N25-2024 MATENIMIENTO E INSTALACIÓN DE EQUIPOSY HERRAMIENTAS PARA SUMINISTRO DE AGUA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "Bases N25",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 08-2024/N25/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const convocatoria009 = [
  {
    nombre: "CONVOCATORIA 09-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 09-2024/CONVOCATORIA 09-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n21 = [
  {
    nombre: "Bases N21",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 09-2024/N21/BASES DE LICITACIÓN EA-913005999-N21-2024 ADQUISICION DE TRANSFORMADORES PARA SUSTITUCION.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "Bases N21",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 09-2024/N21/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const n26 = [
  {
    nombre: "Bases N26",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 09-2024/N26/BASES DE LICITACIÓN EA-913005999-N26-2024 EQUIPAMIENTO DE LA PTAR MATILDE.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "Bases N26",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 09-2024/N26/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
